<template>
  <div id="app">
    <!-- <Header /> -->
    <header class="headerLarge" v-if="onDesktop()">
      <b-col md="3" lg="3" class="">
          <img class="logo" src="@/assets/logoHeader.png" alt="IT Jonction">
      </b-col>
      <b-col md="4" lg="5">
          <b-nav class="right">
              <router-link class="headerLink" to="/">Home</router-link>
              <router-link class="headerLink" to="/process">Process</router-link>
              <router-link class="headerLink" to="/tech">Tech</router-link>
          </b-nav>
      </b-col>
      <b-col md="3" lg="2" class="center">
          <DiscussBtn />
      </b-col>
      <b-col md="2" lg="2" class="center">
          <switchLocale />
      </b-col>
    </header>
    <div v-else>
      <header class="headerSmall" :class="showHeader">
        <img sm="3" class="headerSmallImg" src="@/assets/logoHeader.png" alt="IT Jonction Lab">
        <div sm="9" class="headerSmallDiv">
          <switchLocale />
          <img @click="isOpen = !isOpen" src="@/assets/menuIcon.png" alt="Show menu" class="menuBtn">
        </div>
      </header>

      <div :class="showMenu">
        <div class="smallHeaderMenu">
          <p>Menu</p>
          <div class="closeMenu" @click="isOpen = !isOpen">x</div>
        </div>
        <div class="smallHeaderBody">
          <div @click="footerRedirect('/')" class="headerLinkSmall">Home</div>
          <div @click="footerRedirect('/process')" class="headerLinkSmall">{{$t('link1')}}</div>
          <div @click="footerRedirect('/tech')" class="headerLinkSmall">{{$t('link2')}}</div>
        </div>
      </div>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>
// import Header from './components/Header.vue'
import DiscussBtn from '@/components/DiscussBtn.vue'
import switchLocale from '@/components/switchLocale.vue'

export default {
  name: 'app',
  components: {
    DiscussBtn,
    switchLocale,
    // HeaderSmall
    // Header
  },
  data: function() {
    return {
      isOpen: 0
    }
  },
  computed : {
    showHeader: function() {
        if (this.isOpen == 1) {
            return 'dn'
        } else {
            return 'smallMenu'
        }
    },
    showMenu: function() {
        if (this.isOpen == 1) {
            return 'smallMenu'
        } else {
            return 'dn'
        }
    }
  },
  methods: {
      onDesktop: function() {
          if(window.innerWidth>=768) {
              return 1
          } else {
              return 0
          }
      },
      footerRedirect: function(pathTo) {
          this.$router.push({ path: pathTo })
          window.scrollTo(0,0)
          this.isOpen = !this.isOpen
      }
  }
}
</script>

<style lang="scss">
@import './assets/style/style.scss';

// HEADER CSS
.shadowHeader {
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.1);
}

.headerLarge {
  position:fixed;
  top:0;
  right:0;
  left:0;
  background-color:white;
  z-index:1;
  display:flex;
  justify-content: space-between;
  align-items: center;
  padding: $small 0;
  height:$extra;
  max-width:1140px;
  margin:auto;
}

.headerLink {
  color:$pink;
  margin: 0 25px;
}

ul.nav a {
  color: $pink;
}


.headerSmall {
    display:flex;
    justify-content: space-between;
    align-items:center;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
}

.closeMenu{
    font-size:25px;
}

.smallMenu {
    text-align:center;
    position:fixed;
    width:100%;
    background-color: white;
    top:0;
    height:50px;
    z-index:2;
}

.menuBtn {
    padding:0 0 0 15px;
}

.smallHeaderBody {
    height:120vh;
    background: white;
    display:flex;
    flex-direction: column;
}

.headerSmallDiv{
    display:flex;
    justify-content: space-between;
    align-items:center;
}

.dn {
    display:none;
}

.smallHeaderMenu{
    background: linear-gradient(153.77deg, #772174 0%, #FF2247 100%);
    color:white;
    font-weight:bold;
    display:flex;
    justify-content: space-between;
    align-items:center;
    height: 50px;
    padding: 0 15px;
}

.headerLinkSmall {
    color:#FF2247;
    font-weight: bold;
    padding:25px;
    font-size:25px;
    text-align:center;
}

.headerSmallImg {
    max-width:150px;
}





@media (max-width:1050px) {
  .headerLink {
    margin: 0 15px;
  }
}

@media (max-width:800px) {
  .headerLink {
    margin: 0 10px;
  }
}

/* * { background-color: rgba(255,0,0,.2); }
* * { background-color: rgba(0,255,0,.2); }
* * * { background-color: rgba(0,0,255,.2); }
* * * * { background-color: rgba(255,0,255,.2); }
* * * * * { background-color: rgba(0,255,255,.2); }
* * * * * * { background-color: rgba(255,255,0,.2); }
* * * * * * * { background-color: rgba(255,0,0,.2); }
* * * * * * * * { background-color: rgba(0,255,0,.2); }
* * * * * * * * * { background-color: rgba(0,0,255,.2); } */
</style>
